import { render } from "./Netflixtrending.vue?vue&type=template&id=0eb14ef0&scoped=true"
import script from "./Netflixtrending.vue?vue&type=script&lang=js"
export * from "./Netflixtrending.vue?vue&type=script&lang=js"

import "./Netflixtrending.vue?vue&type=style&index=0&id=0eb14ef0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0eb14ef0"

export default script